import axios from "axios";

import { getEnvironmentFromHost } from "./environment";
import { getTenantFromSubdomain } from "./tenant";

export default async function getBackendUrl(): Promise<string> {
  const tenant = getTenantFromSubdomain();
  const environment = getEnvironmentFromHost();

  try {
    const response = await axios.get(
      `/tenant-metadata/${environment}/${tenant}.json`
    );
    if (response.data?.backendUrl) {
      return response.data.backendUrl;
    }
  } catch (e: any) {
    if (e.response && e.response.status === 404) {
      // there is no backend URL override for this tenant -- do nothing
    } else {
      throw e;
    }
  }

  const response = await axios.get(
    `/tenant-metadata/${environment}/shared.json`
  );
  return response.data.backendUrl;
}
